import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import './index.css';
// montserrat FONT
//import '@fontsource/montserrat/300.css';
//import '@fontsource/montserrat/400.css';
//import '@fontsource/montserrat/500.css';
//import '@fontsource/montserrat/700.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
    <App />
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
